/**
 * 지역 홍보 대상 선택 — 행정구역(시/도·시/군구) 코드 정적 표(설계 §자율 결정 1).
 *
 * 🚨 허브 전체(#712~#731)를 뒤져도 시/도·시/군구 **목록을 내려주는 GET EP가 없다** — `#731` §2
 * 견적 응답은 선택된 지역의 코드+이름만 되돌려줄 뿐 옵션 목록을 주지 않는다. 예시 값
 * (`stateId:"11"`=서울특별시, `cityId:"11680"`=강남구)이 행정안전부 법정동코드 표준 표기와 정확히
 * 일치함을 확인했다 — 이 표는 그 공공데이터 표준 코드를 그대로 옮긴 정적 참조 데이터다(자체 채번 아님).
 *
 * 🔸 시/군/구가 없는 도(道) 지역(세종특별자치시 등)은 `cities: []`로 둔다 — 화면은 "시/도 전체"만
 * 선택 가능하게 처리한다(`regionCityId: null`).
 */

export interface RegionCity {
  cityId: string
  cityName: string
}

export interface RegionState {
  stateId: string
  stateName: string
  cities: RegionCity[]
}

export const REGION_STATES: RegionState[] = [
  {
    stateId: '11',
    stateName: '서울특별시',
    cities: [
      { cityId: '11110', cityName: '종로구' },
      { cityId: '11140', cityName: '중구' },
      { cityId: '11170', cityName: '용산구' },
      { cityId: '11200', cityName: '성동구' },
      { cityId: '11215', cityName: '광진구' },
      { cityId: '11230', cityName: '동대문구' },
      { cityId: '11260', cityName: '중랑구' },
      { cityId: '11290', cityName: '성북구' },
      { cityId: '11305', cityName: '강북구' },
      { cityId: '11320', cityName: '도봉구' },
      { cityId: '11350', cityName: '노원구' },
      { cityId: '11380', cityName: '은평구' },
      { cityId: '11410', cityName: '서대문구' },
      { cityId: '11440', cityName: '마포구' },
      { cityId: '11470', cityName: '양천구' },
      { cityId: '11500', cityName: '강서구' },
      { cityId: '11530', cityName: '구로구' },
      { cityId: '11545', cityName: '금천구' },
      { cityId: '11560', cityName: '영등포구' },
      { cityId: '11590', cityName: '동작구' },
      { cityId: '11620', cityName: '관악구' },
      { cityId: '11650', cityName: '서초구' },
      { cityId: '11680', cityName: '강남구' },
      { cityId: '11710', cityName: '송파구' },
      { cityId: '11740', cityName: '강동구' },
    ],
  },
  {
    stateId: '26',
    stateName: '부산광역시',
    cities: [
      { cityId: '26110', cityName: '중구' },
      { cityId: '26140', cityName: '서구' },
      { cityId: '26170', cityName: '동구' },
      { cityId: '26200', cityName: '영도구' },
      { cityId: '26230', cityName: '부산진구' },
      { cityId: '26260', cityName: '동래구' },
      { cityId: '26290', cityName: '남구' },
      { cityId: '26320', cityName: '북구' },
      { cityId: '26350', cityName: '해운대구' },
      { cityId: '26380', cityName: '사하구' },
      { cityId: '26410', cityName: '금정구' },
      { cityId: '26440', cityName: '강서구' },
      { cityId: '26470', cityName: '연제구' },
      { cityId: '26500', cityName: '수영구' },
      { cityId: '26530', cityName: '사상구' },
      { cityId: '26710', cityName: '기장군' },
    ],
  },
  {
    stateId: '27',
    stateName: '대구광역시',
    cities: [
      { cityId: '27110', cityName: '중구' },
      { cityId: '27140', cityName: '동구' },
      { cityId: '27170', cityName: '서구' },
      { cityId: '27200', cityName: '남구' },
      { cityId: '27230', cityName: '북구' },
      { cityId: '27260', cityName: '수성구' },
      { cityId: '27290', cityName: '달서구' },
      { cityId: '27710', cityName: '달성군' },
    ],
  },
  {
    stateId: '28',
    stateName: '인천광역시',
    cities: [
      { cityId: '28110', cityName: '중구' },
      { cityId: '28140', cityName: '동구' },
      { cityId: '28177', cityName: '미추홀구' },
      { cityId: '28185', cityName: '연수구' },
      { cityId: '28200', cityName: '남동구' },
      { cityId: '28237', cityName: '부평구' },
      { cityId: '28245', cityName: '계양구' },
      { cityId: '28260', cityName: '서구' },
      { cityId: '28710', cityName: '강화군' },
      { cityId: '28720', cityName: '옹진군' },
    ],
  },
  {
    stateId: '29',
    stateName: '광주광역시',
    cities: [
      { cityId: '29110', cityName: '동구' },
      { cityId: '29140', cityName: '서구' },
      { cityId: '29155', cityName: '남구' },
      { cityId: '29170', cityName: '북구' },
      { cityId: '29200', cityName: '광산구' },
    ],
  },
  {
    stateId: '30',
    stateName: '대전광역시',
    cities: [
      { cityId: '30110', cityName: '동구' },
      { cityId: '30140', cityName: '중구' },
      { cityId: '30170', cityName: '서구' },
      { cityId: '30200', cityName: '유성구' },
      { cityId: '30230', cityName: '대덕구' },
    ],
  },
  {
    stateId: '31',
    stateName: '울산광역시',
    cities: [
      { cityId: '31110', cityName: '중구' },
      { cityId: '31140', cityName: '남구' },
      { cityId: '31170', cityName: '동구' },
      { cityId: '31200', cityName: '북구' },
      { cityId: '31710', cityName: '울주군' },
    ],
  },
  { stateId: '36', stateName: '세종특별자치시', cities: [] },
  {
    stateId: '41',
    stateName: '경기도',
    cities: [
      { cityId: '41111', cityName: '수원시 장안구' },
      { cityId: '41113', cityName: '수원시 권선구' },
      { cityId: '41115', cityName: '수원시 팔달구' },
      { cityId: '41117', cityName: '수원시 영통구' },
      { cityId: '41131', cityName: '성남시 수정구' },
      { cityId: '41133', cityName: '성남시 중원구' },
      { cityId: '41135', cityName: '성남시 분당구' },
      { cityId: '41150', cityName: '의정부시' },
      { cityId: '41170', cityName: '안양시' },
      { cityId: '41190', cityName: '부천시' },
      { cityId: '41210', cityName: '광명시' },
      { cityId: '41220', cityName: '평택시' },
      { cityId: '41250', cityName: '동두천시' },
      { cityId: '41270', cityName: '안산시' },
      { cityId: '41280', cityName: '고양시' },
      { cityId: '41290', cityName: '과천시' },
      { cityId: '41310', cityName: '구리시' },
      { cityId: '41360', cityName: '남양주시' },
      { cityId: '41370', cityName: '오산시' },
      { cityId: '41390', cityName: '시흥시' },
      { cityId: '41410', cityName: '군포시' },
      { cityId: '41430', cityName: '의왕시' },
      { cityId: '41450', cityName: '하남시' },
      { cityId: '41460', cityName: '용인시' },
      { cityId: '41480', cityName: '파주시' },
      { cityId: '41500', cityName: '이천시' },
      { cityId: '41550', cityName: '안성시' },
      { cityId: '41570', cityName: '김포시' },
      { cityId: '41590', cityName: '화성시' },
      { cityId: '41610', cityName: '광주시' },
      { cityId: '41630', cityName: '양주시' },
      { cityId: '41650', cityName: '포천시' },
      { cityId: '41670', cityName: '여주시' },
      { cityId: '41800', cityName: '연천군' },
      { cityId: '41820', cityName: '가평군' },
      { cityId: '41830', cityName: '양평군' },
    ],
  },
  {
    stateId: '43',
    stateName: '충청북도',
    cities: [
      { cityId: '43111', cityName: '청주시 상당구' },
      { cityId: '43112', cityName: '청주시 서원구' },
      { cityId: '43113', cityName: '청주시 흥덕구' },
      { cityId: '43114', cityName: '청주시 청원구' },
      { cityId: '43130', cityName: '충주시' },
      { cityId: '43150', cityName: '제천시' },
      { cityId: '43720', cityName: '보은군' },
      { cityId: '43730', cityName: '옥천군' },
      { cityId: '43740', cityName: '영동군' },
      { cityId: '43745', cityName: '증평군' },
      { cityId: '43750', cityName: '진천군' },
      { cityId: '43760', cityName: '괴산군' },
      { cityId: '43770', cityName: '음성군' },
      { cityId: '43800', cityName: '단양군' },
    ],
  },
  {
    stateId: '44',
    stateName: '충청남도',
    cities: [
      { cityId: '44131', cityName: '천안시 동남구' },
      { cityId: '44133', cityName: '천안시 서북구' },
      { cityId: '44150', cityName: '공주시' },
      { cityId: '44180', cityName: '보령시' },
      { cityId: '44200', cityName: '아산시' },
      { cityId: '44210', cityName: '서산시' },
      { cityId: '44230', cityName: '논산시' },
      { cityId: '44250', cityName: '계룡시' },
      { cityId: '44270', cityName: '당진시' },
      { cityId: '44710', cityName: '금산군' },
      { cityId: '44760', cityName: '부여군' },
      { cityId: '44770', cityName: '서천군' },
      { cityId: '44790', cityName: '청양군' },
      { cityId: '44800', cityName: '홍성군' },
      { cityId: '44810', cityName: '예산군' },
      { cityId: '44825', cityName: '태안군' },
    ],
  },
  {
    stateId: '45',
    stateName: '전라북도',
    cities: [
      { cityId: '45111', cityName: '전주시 완산구' },
      { cityId: '45113', cityName: '전주시 덕진구' },
      { cityId: '45130', cityName: '군산시' },
      { cityId: '45140', cityName: '익산시' },
      { cityId: '45180', cityName: '정읍시' },
      { cityId: '45190', cityName: '남원시' },
      { cityId: '45210', cityName: '김제시' },
      { cityId: '45710', cityName: '완주군' },
      { cityId: '45720', cityName: '진안군' },
      { cityId: '45730', cityName: '무주군' },
      { cityId: '45740', cityName: '장수군' },
      { cityId: '45750', cityName: '임실군' },
      { cityId: '45770', cityName: '순창군' },
      { cityId: '45790', cityName: '고창군' },
      { cityId: '45800', cityName: '부안군' },
    ],
  },
  {
    stateId: '46',
    stateName: '전라남도',
    cities: [
      { cityId: '46110', cityName: '목포시' },
      { cityId: '46130', cityName: '여수시' },
      { cityId: '46150', cityName: '순천시' },
      { cityId: '46170', cityName: '나주시' },
      { cityId: '46230', cityName: '광양시' },
      { cityId: '46710', cityName: '담양군' },
      { cityId: '46720', cityName: '곡성군' },
      { cityId: '46730', cityName: '구례군' },
      { cityId: '46770', cityName: '고흥군' },
      { cityId: '46780', cityName: '보성군' },
      { cityId: '46790', cityName: '화순군' },
      { cityId: '46800', cityName: '장흥군' },
      { cityId: '46810', cityName: '강진군' },
      { cityId: '46820', cityName: '해남군' },
      { cityId: '46830', cityName: '영암군' },
      { cityId: '46840', cityName: '무안군' },
      { cityId: '46860', cityName: '함평군' },
      { cityId: '46870', cityName: '영광군' },
      { cityId: '46880', cityName: '장성군' },
      { cityId: '46890', cityName: '완도군' },
      { cityId: '46900', cityName: '진도군' },
      { cityId: '46910', cityName: '신안군' },
    ],
  },
  {
    stateId: '47',
    stateName: '경상북도',
    cities: [
      { cityId: '47111', cityName: '포항시 남구' },
      { cityId: '47113', cityName: '포항시 북구' },
      { cityId: '47130', cityName: '경주시' },
      { cityId: '47150', cityName: '김천시' },
      { cityId: '47170', cityName: '안동시' },
      { cityId: '47190', cityName: '구미시' },
      { cityId: '47210', cityName: '영주시' },
      { cityId: '47230', cityName: '영천시' },
      { cityId: '47250', cityName: '상주시' },
      { cityId: '47280', cityName: '문경시' },
      { cityId: '47290', cityName: '경산시' },
      { cityId: '47720', cityName: '군위군' },
      { cityId: '47730', cityName: '의성군' },
      { cityId: '47750', cityName: '청송군' },
      { cityId: '47760', cityName: '영양군' },
      { cityId: '47770', cityName: '영덕군' },
      { cityId: '47820', cityName: '청도군' },
      { cityId: '47830', cityName: '고령군' },
      { cityId: '47840', cityName: '성주군' },
      { cityId: '47850', cityName: '칠곡군' },
      { cityId: '47900', cityName: '예천군' },
      { cityId: '47920', cityName: '봉화군' },
      { cityId: '47930', cityName: '울진군' },
      { cityId: '47940', cityName: '울릉군' },
    ],
  },
  {
    stateId: '48',
    stateName: '경상남도',
    cities: [
      { cityId: '48121', cityName: '창원시 의창구' },
      { cityId: '48123', cityName: '창원시 성산구' },
      { cityId: '48125', cityName: '창원시 마산합포구' },
      { cityId: '48127', cityName: '창원시 마산회원구' },
      { cityId: '48129', cityName: '창원시 진해구' },
      { cityId: '48170', cityName: '진주시' },
      { cityId: '48220', cityName: '통영시' },
      { cityId: '48240', cityName: '사천시' },
      { cityId: '48250', cityName: '김해시' },
      { cityId: '48270', cityName: '밀양시' },
      { cityId: '48310', cityName: '거제시' },
      { cityId: '48330', cityName: '양산시' },
      { cityId: '48720', cityName: '의령군' },
      { cityId: '48730', cityName: '함안군' },
      { cityId: '48740', cityName: '창녕군' },
      { cityId: '48820', cityName: '고성군' },
      { cityId: '48840', cityName: '남해군' },
      { cityId: '48850', cityName: '하동군' },
      { cityId: '48860', cityName: '산청군' },
      { cityId: '48870', cityName: '함양군' },
      { cityId: '48880', cityName: '거창군' },
      { cityId: '48890', cityName: '합천군' },
    ],
  },
  {
    stateId: '50',
    stateName: '제주특별자치도',
    cities: [
      { cityId: '50110', cityName: '제주시' },
      { cityId: '50130', cityName: '서귀포시' },
    ],
  },
  {
    stateId: '51',
    stateName: '강원특별자치도',
    cities: [
      { cityId: '51110', cityName: '춘천시' },
      { cityId: '51130', cityName: '원주시' },
      { cityId: '51150', cityName: '강릉시' },
      { cityId: '51170', cityName: '동해시' },
      { cityId: '51190', cityName: '태백시' },
      { cityId: '51210', cityName: '속초시' },
      { cityId: '51230', cityName: '삼척시' },
      { cityId: '51720', cityName: '홍천군' },
      { cityId: '51730', cityName: '횡성군' },
      { cityId: '51750', cityName: '영월군' },
      { cityId: '51760', cityName: '평창군' },
      { cityId: '51770', cityName: '정선군' },
      { cityId: '51780', cityName: '철원군' },
      { cityId: '51790', cityName: '화천군' },
      { cityId: '51800', cityName: '양구군' },
      { cityId: '51810', cityName: '인제군' },
      { cityId: '51820', cityName: '고성군' },
      { cityId: '51830', cityName: '양양군' },
    ],
  },
]

export function citiesForState(stateId: string | null): RegionCity[] {
  if (!stateId) return []
  return REGION_STATES.find((state) => state.stateId === stateId)?.cities ?? []
}

export function regionStateName(stateId: string | null): string | null {
  if (!stateId) return null
  return REGION_STATES.find((state) => state.stateId === stateId)?.stateName ?? null
}

export function regionCityName(stateId: string | null, cityId: string | null): string | null {
  if (!stateId || !cityId) return null
  return citiesForState(stateId).find((city) => city.cityId === cityId)?.cityName ?? null
}
